<template>
  <div>
    <v-container
      fluid
      class="d-flex justify-center align-center"
      style="min-height: 90vh"
    >
      <v-card class="rounded-xl elevation-4 pa-6" max-width="800" width="100%">
        <v-card-title class="justify-center pb-4 text-center">
          <span class="text-h6 font-weight-bold">
            Check In
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="MeetingLoaded" class="pt-6">
          <v-container>
            <v-row dense>
              <v-col cols="12" md="6">
                <p style="font-size: 16px">
                  <b style="color: black">Booking Name :</b> {{ BookingName }}</p>
                <p style="font-size: 16px">
                  <b style="color: black">Date/Time :</b> {{ DateTime }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p style="font-size: 16px">
                  <b style="color: black">Room :</b> {{ RoomName }}</p>
                <p style="font-size: 16px">
                  <b style="color: black">HostName :</b> {{ HostName }}</p>
              </v-col>
            </v-row>
            <v-row dense justify="center pt-6">
              <v-col cols="12" md="8" class="d-flex justify-center">
                <v-btn
                  color="green"
                  width="150"
                  class="mr-4 white--text rounded-lg"
                  large
                  :loading="LoadingDialog"
                  :disabled="LoadingDialog || CheckInStatus === true"
                  @click="checkInMeeting()"
                >
                  Check In
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text v-else class="pt-8 pb-8 text-center">
          <v-icon size="56" color="#00378e">mdi-calendar-search</v-icon>
          <div class="mt-4 text-h6 font-weight-bold">
            {{ EmptyMessage }}
          </div>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card class="pa-6 d-flex flex-column align-center justify-center" elevation="8" rounded="xl">
        <v-progress-circular indeterminate color="indigo" size="70" width="6"></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium">Loading, please wait...</span>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "CheckinMeeting",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      BookingName: "",
      RoomName: "",
      DateTime: "",
      HostName: "",
      CheckInStatus: "",
      EventID: "",
      MeetingLoaded: false,
      EmptyMessage: "Loading meeting...",
    };
  },

  async mounted() {
    let self = this;
    self.EventID = self.$route.params.eventID || "";
    if (self.EventID) {
      self.getDataMeetingForCheckIn(self.EventID);
    } else {
      self.EmptyMessage = "Meeting not found.";
    }
  },

  methods: {
    getDataMeetingForCheckIn(eventID) {
      let self = this;
      let temp = {
        eventID: eventID,
      };
      self.LoadingDialog = true;
      axios
        .post(`${self.url}Calendar/getDataMeetingForCheckInOffice365ByEventID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.BookingName = response.data.data.bookingName;
            self.HostName = response.data.data.hostName;
            self.DateTime = self.ChangeFormatDate(response.data.data.startDate) + " - " + self.ChangeFormatDate(response.data.data.expireDate);
            self.RoomName = response.data.data.roomName;
            self.CheckInStatus = response.data.data.checkinStatus;
            self.MeetingLoaded = true;
          } else {
            self.EmptyMessage = response.data.message || "Meeting not found.";
          }
        })
        .catch(function (error) {
          self.EmptyMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Meeting not found.";
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: self.EmptyMessage,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    checkInMeeting() {
      let self = this;
      let temp = {
        eventID: self.EventID,
      };
      self.LoadingDialog = true;
      axios
        .post(`${self.url}Calendar/checkInMeetingOffice365ByEventID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.CheckInStatus = true;
            Swal.fire({
              icon: "success",
              title: "Check In Successful",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            throw new Error(response.data.message || "Check in failed");
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text:
              error?.response?.data?.message ||
              error?.message ||
              "Check in failed",
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
<style scoped></style>
